<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="订单成功" left-arrow fixed  @click-left="back" />
        <van-row>
          <van-col span="4"></van-col>
          <van-col span="16">
              <div class="jump-order-body">
                <div class="jump-order-body-whd">
                    <van-icon name="success" />
                    <p>订单已提交，请等待审核结果!</p>
                </div>
                <div class="jump-order-body-foot">
                    <p>订单金额：<span>{{orderPrice}}元</span></p>
                    <p>订单编号：<span>{{orderId}}</span></p>
                    <div v-if="integralMsgShow">
                       <p>预计可获得积分：<span>{{getIntegral}}</span></p>
                        <p>当前持有积分：<span>{{userIntegral}}</span></p>
                        <p>可兑换商品：<span>{{availableQuantity}}</span>种<a style="color:red;margin-left:20px" href="#/integral/home">去兑换>></a></p>
                    </div>
                     <p v-if="pointAmount>0">积分抵扣金额：<span>{{pointAmount}}</span></p>
                    <p>
                       <a href="https://www.wjx.cn/vm/Q3zNsam.aspx" style="color: #3c6eeb;text-decoration: underline;font-size:19px">第一季度满意度调查</a>
                    </p>
                    <van-button size="large" url="#/home">继续逛逛</van-button>
                </div>
            </div>
          </van-col>
          <van-col span="4"></van-col>
        </van-row>
    </div>
</template>
<script>
import { NavBar,Button,Row,Col } from "vant";
export default {
  name: "ordersuccess",
  components: {
    [NavBar.name]: NavBar,
    [Button.name]:Button,
    [Row.name]:Row,
    [Col.name]:Col
  },
  data() {
    return {
      orderId:0,
      orderPrice:0,
      pointAmount:0,
      getIntegral:0,
      availableQuantity:0,
      userIntegral:0,
      integralMsgShow:false
    };
  },
  methods: {
    back() {
      // history.back();
      this.$router.push('/home');
    }
  },
  mounted(){
    this.orderId = this.$route.query.orderId;
    this.orderPrice = this.$route.query.orderPrice;
    this.pointAmount = this.$route.query.pointAmount;

    this.getIntegral = this.$route.query.getIntegral;
    this.availableQuantity = this.$route.query.availableQuantity;
    this.userIntegral = this.$route.query.userIntegral;
    this.integralMsgShow=this.$route.query.integralMsgShow=='true'?true:false;
  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;
body {
  background-color: #f7f7f7;
}
.jump-order {
  padding-top: 50px;

  &-body {
    padding-top: 100px;
    &-whd {
      text-align: center;
      i {
        color: #fff;
        border-color: #1989fa;
        background-color: #1989fa;
        border-radius: 100%;
        font-size: 56px;
      }
      p{
        padding: 20px 0;
      }
    }
    &-foot{
      p{
        padding-left: 15px;
        margin-bottom: 10px;
        span{
          color: red;
        }
      }
      button{
        background-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 5px;
        margin: 25px 0 10px;
      }
    }
  }
}
</style>


